// В это файле не должно быть импортов чтобы не усложнять жизнь cli/actions/configs.js
var MS_IN_ONE_MINUTE = 60 * 1000;
export var VERSION = 8; // Тут нужно менять версию если поля добавляются не в конец
export var defaultSettings = {
    updated: 0,
    lifeTime: 15 * MS_IN_ONE_MINUTE,
    // Нативная реклама
    nativeInterval: (FOR_YANDEX ? 180 : 180) + 10,
    nativeTimeout: (FOR_YANDEX ? 55 : 25) + 5,
    rewardedInterval: 180,
    adFreeHoursAfterPurchase: FOR_YANDEX ? 0 : 0,
    adFreeHoursForNewUsers: FOR_YANDEX ? 24 : 24,
    vkUseWaterfall: true,
    showNativeAfterMove: FOR_YANDEX ? true : true,
    showNativeOnCloseModal: true,
    showNativeOnHighScore: FOR_YANDEX ? false : false,
    showNativeOnReply: true,
    nativeLimit: FOR_YANDEX ? 1000 : 30,
    nativeEffectType: FOR_YANDEX ? 2 : 0,
    nativeEffectTime: 2700,
    nativeEffectSpeed: 125,
    uiDisabledOnNativeEffect: false,
    // Цены
    rewardBonus: 500,
    hintPrice: 100,
    undoPrice: 100,
    // Фичи
    useStartScreen: true,
    useRemoteCSS: false,
    useRemoteJS: false,
    useCoupBtn: true,
    sendErrorReport: true,
};
export var STORAGE_KEY = "settings-v".concat(VERSION);
export var REMOTE_URL = 'https://static.papergame.ru/s';
export var REMOTE_FILE = "".concat(PACKAGE_NAME, "-").concat(STORE, "-v").concat(VERSION, ".txt");
// const current: any = {
//   updated: 0,
//   lifeTime: 900000,
//   nativeInterval: 3,
//   nativeTimeout: 1,
//   rewardedInterval: 3,
//   adFreeDaysAfterPurchase: 0,
//   adFreeDaysForNewUsers: 1,
//   vkUseWaterfall: true,
//   showNativeAfterMove: true,
//   nativeLimit: 1000,
//   rewardBonus: 500,
//   hintPrice: 100,
//   undoPrice: 100,
// }
// for (let key in defaultSettings) {
//   // @ts-ignore
//   if (!current[key] || current[key] !== defaultSettings[key]) {
//     // @ts-ignore
//     console.log({key, current: current[key], default: defaultSettings[key]})
//   }
// }
